import React, { useState, useEffect, useCallback, version } from 'react'
import {Col, Row, Button, Collapse} from 'react-bootstrap'
import {useNavigate} from 'react-router'
import './Course.css'
import {ToNotify} from '../Shared/ViewControl'
import {OnAction} from '../Shared/ActionControl'
import { viewDate, toDate, styleRegister } from '../Shared/Formating'
import CourseModal from './CourseModal' 
import {Get, Fetch, Cookie} from '../Api'
import {InVersion} from '../Shared/InputControl'

const Courses = ({onCourse, global, search="", role}) => {
    const entity='Course'
    const [loaded, Load] = useState(false)
    const [items, Items] = useState([])
    const [message, Message] = useState('')
    const [action, Action] = useState({id:0, crud:0, show:false})
    const [fetched, Fetched] = useState(false)
    const [entities, Entities]= useState({Course:true, Bloqued: false})

    const version = Cookie('meVersion') ?? 1
    //alert(version)

    const onCollapse = (e) => {
        Entities({...entities, [e.target.name]: !entities[e.target.name]})
    }

    useEffect(() => {
        if(!loaded) {
            Get(entity, Items, Load, Message)
            sessionStorage.setItem("routeCurrent","/course")
        }
        //console.log('Courses...', items)
    }, [loaded])    


    let filteredItems = items.filter(
        (item)=>{
            return (item.Title+item.Content+item.Manager).indexOf(search)!==-1;
    })

    const onHide = () => {
        if(fetched) {
            Load(false)
            Fetched(false)
        }
        Action({...action,show:false, crud:0})
    }

    const onRegister = (item) => {
        if(item.Status===1) {
            let request=`${entity}/Register/${item.Id}`
            let success = `تم طلب التسجيل في ${item.Title} !`
            Fetch(request, null, 1, Load, Message, null, null, success) // window.location.reload() not needed because Load(false) in Fetch !
        }
        else {
            console.log('onRegister ?', item.Status)   
        }
    }
    
    return (
<>

{ loaded ?
<>
    <div className="Elements">        
    {
        filteredItems.filter((item)=>{return (item.Status===3) }).map(item=>
            <Course key={`Course-${item.Id}`}
            item={item}
            icon="./images/hifd.png" 
            onAction={Action} 
            onCourse={onCourse}
            role={role}
            version={version}
        />)
    }

    { action.show ?
            <CourseModal
            global={global}
            action={action}
            onHide={onHide}
            Fetched={Fetched}
            Message={Message}
            />
    : null }
</div>

    <div style={{border:"12px solid green", borderRadius:"15px", justifyContent:"center",  margin:'2rem auto', width:'80%'}}>         

        <Button name="Course" onClick={onCollapse} 
        style={{backgroundColor:"green", borderColor:"gold", textAlign:'right', width:'100%'}}>
        {"الدورات المتاحة"} 
        </Button>   
        <Collapse in={entities.Course}>
        <div className="Elements">
        {
        filteredItems.filter((item)=>{return (item.Status!==3)}).map(item=>
            <Course key={`Course-${item.Id}`}
            item={item}
            icon="./images/hifd.png" 
            onAction={Action} 
            onRegister={onRegister}
            onCourse={onCourse}
            role={role}
            version={version}
        />)
        }
        
        </div>
        </Collapse>
    </div> 
</>

: <h6>{entity} is loading...</h6> }

<ToNotify message={message} onClose={()=>Message('')} />

</>
        )
}


const Course = ({item, icon, onAction, onRegister, onCourse, role, version}) => {
    const navigate = useNavigate();

    const onMemorizing = useCallback(() => navigate(`/memorizing`,{replace:true}), [navigate])
    const onMeditating = useCallback(() => navigate(`/meditating`,{replace:true}), [navigate])
    const onRepetition = useCallback(() => navigate(`/repetition`,{replace:true}), [navigate])

    const onClick = (id) => {
        if(id>1) {
            document.cookie = `meCourse=${id}`
            onCourse(id)
        }
    }
  
    const cstyle={fontSize: '1rem', justifyContent:'center', color:'white' }

    let sitem = styleRegister(item)

    return (
        <div className='Element' key={`Course-${item.Id}`}>
            <Col style={{width: "calc(100% - 3px)"}} onClick={()=>onClick(item.Id)}>
                <div className="center">
                    <img src={icon} alt={item.Manager+":"+item.Title} onClick={onMemorizing} />
                </div>

                <Row style={{...cstyle, fontWeight: 'bold', color:'yellow', marginTop:'1rem'}}>{item.Manager}</Row>
                <Row style={{...cstyle, fontWeight: 'bold', textAlign:'right', margin:'1rem auto', fontSize: '1.2rem'}}>{item.Title}</Row>
                <Row style={{...cstyle, color:'cyan', marginBottom:'.6rem'}}>{item.Level}</Row>

                <Row style={{...cstyle, fontSize: '0.9rem', display: 'none'}}>{item.Content}</Row>

{ role>1 ?
                <Row style={{margin:'0.5rem'}}>
                <Col className="Action" id={item.Id} sm={4}
                    onClick={onMemorizing}>{"حفظ"}</Col>
                <Col className="Action" id={item.Id} sm={4}
                    onClick={onRepetition}>{"تكرار"}</Col>
                { role>6 ?
                <Col className="Action" id={item.Id} sm={4}
                    onClick={onMeditating}>{"تدبر"}</Col>
                :null}
                </Row>
: null}
                <Row><InVersion version={version} /></Row>
         
{ onRegister && item?.Role<3 ? 
    <div className='toRegister' style={sitem.style} onClick={()=>onRegister(item)}>{sitem.label}</div>
: null}   
            </Col>

            {item.Role>1? 
            <OnAction 
            onEdit={ ()=>onAction({id:item.Id, crud:3, show:true}) } 
            onExpand= { item.Role>5 ? ()=>onAction({id:item.Id, crud:2, show:true}) : null }
            />     
            : null}        
        </div>
    )


}

export {Courses}

/*
    <Row style={{marginTop:'0.5rem'}}>
    <Col sm={7} style={{...cstyle, color: 'cyan'}}>{viewDate(item.Starts, false)}</Col>
    <Col sm={5} style={{...cstyle, color: 'cyan'}}>{toDate(item.Ends).substring(5)}</Col>
    </Row>

*/